module.exports = __webpack_public_path__ + "img/pic_home_case_1.65907ebe.png";